webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./favicon.png": 43,
	"./gradient.png": 13,
	"./projects/previews/afrs_preview.png": 44,
	"./projects/previews/capstone_preview_2.png": 45,
	"./projects/previews/healthnet_preview.png": 46,
	"./projects/previews/main_background_small.jpg": 47,
	"./projects/previews/pantreats_preview.png": 48,
	"./projects/previews/raytrace.png": 49,
	"./projects/previews/thesis_placeholder.jpg": 50,
	"./projects/previews/vue-website-icon.png": 51,
	"./projects/previews/vue-website-icon2.png": 52,
	"./projects/previews/website_preview_3.png": 53,
	"./test.png": 54,
	"./website-data": 3,
	"./website-data.json": 3
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1;

/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

module.exports = {"welcomePage":{"websiteName":"Robert Nill - Software Engineer","description":"Howdy! Feel free to look at some of my projects, or look at my resume!","recentEvents":[{"description":"M.S. in Computer Science at RIT","dateText":"May '20"},{"description":"B.S. in Software Engineering at RIT","dateText":"May '19"},{"description":"Co-op Block @ RIT SITO","dateText":"May - Aug '19"},{"description":"Teaching Assistant - Intro to Software Engineering","dateText":"Aug '18 - May '19"},{"description":"Co-op Block @ Curriculum Associates","dateText":"Jan - Jun '18"},{"description":"Society of Software Engineers Mentor","dateText":"Aug - Dec '17"},{"description":"Teaching Assistant - Intro to Software Engineering","dateText":"Aug - Dec '17"},{"description":"Double Co-op Block @ Northrop Grumman","dateText":"Jan - Aug '17"}],"previewImages":{"left":["gradient.png","gradient.png","gradient.png","gradient.png"],"right":["gradient.png","gradient.png","gradient.png","gradient.png"],"center":"gradient.png"}},"projects":[{"preview":{"name":"Healthnet","description":"Hospital management & patient registration system.","startDate":"01/16","endDate":"05/16","images":[{"name":"Image","img":"projects/previews/healthnet_preview.png"}],"tags":[{"text":"Class Project","icon":"fas fa-graduation-cap"},{"text":"Python","icon":"fab fa-python"}]}},{"preview":{"name":"AFRS","description":"Mock text-API for reserving flights and querying airport data.","startDate":"09/16","endDate":"12/16","images":[{"name":"Image","img":"projects/previews/afrs_preview.png"}],"tags":[{"text":"Class Project","icon":"fas fa-graduation-cap"},{"text":"Java","icon":"fas fa-coffee"}]}},{"preview":{"name":"Pantreats","description":"Web application for exploring recipes based on the ingredients in your kitchen.","startDate":"09/17","endDate":"12/17","images":[{"name":"Image","img":"projects/previews/pantreats_preview.png"}],"links":[{"text":"GitHub","url":"https://github.com/Sypherio/swen444-pantreats"}],"tags":[{"text":"Class Project","icon":"fas fa-graduation-cap"},{"text":"JavaScript","icon":"fab fa-js-square"},{"text":"VueJS","icon":"fab fa-vuejs"}]}},{"preview":{"name":"This Website!","description":"Portfolio and a spot for cool things.","startDate":"01/18","endDate":"Now","images":[{"name":"Image","img":"projects/previews/website_preview_3.png"}],"links":[{"text":"GitHub","url":"https://github.com/rmnill202/vuewebsite"}],"tags":[{"text":"Personal Project","icon":"fas fa-user-circle"},{"text":"JavaScript","icon":"fab fa-js-square"},{"text":"VueJS","icon":"fab fa-vuejs"}]}},{"preview":{"name":"Supply Chain Visibility","description":"Mobile app that helps Wegmans employees determine root causes of supply chain problems.","startDate":"08/18","endDate":"06/19","images":[{"name":"Image","img":"projects/previews/capstone_preview_2.png"}],"links":[{"text":"Website","url":"http://www.se.rit.edu/~wegpeople/index.html"}],"tags":[{"text":"Capstone Project (SE)","icon":"fas fa-graduation-cap"},{"text":".NET & Azure","icon":"fab fa-microsoft"},{"text":"Mobile App","icon":"fas fa-mobile-alt"}]}},{"preview":{"name":"Java Ray Tracer","description":"Simple Java-based ray tracer","startDate":"10/18","endDate":"Now","images":[{"name":"Image","img":"projects/previews/raytrace.png"}],"links":[{"text":"Website","url":"https://rmnill202.github.io/711-raytracer"}],"tags":[{"text":"Personal Project","icon":"fas fa-user-circle"},{"text":"Class Project","icon":"fas fa-graduation-cap"},{"text":"Graphics Work","icon":"fas fa-lightbulb"},{"text":"Java","icon":"fas fa-coffee"},{"text":"OpenCL","icon":"fas fa-th"}]}},{"preview":{"name":"Thesis Work","description":"Related to computer graphics and/or machine learning.","startDate":"06/19","endDate":"Now","images":[{"name":"Image","img":"projects/previews/thesis_placeholder.jpg"}],"tags":[{"text":"Graduate Work","icon":"fas fa-graduation-cap"},{"text":"Graphics Work","icon":"fas fa-lightbulb"},{"text":"Machine Learning","icon":"fas fa-brain"}]}}],"about":[{"name":"Software","description":"I'm a software engineer!","icon":"fas fa-code","image":{"name":"TO DO","img":"gradient.png"}},{"name":"Music","description":"Super into alt/prog rock","icon":"fas fa-headphones","image":{"name":"TO DO","img":"gradient.png"}},{"name":"Games","description":"Especially VR","icon":"fas fa-gamepad","image":{"name":"TO DO","img":"gradient.png"}},{"name":"UX","description":"I love UI work","icon":"fas fa-user","image":{"name":"TO DO","img":"gradient.png"}},{"name":"3D Printing","description":"Prusa i3 MK3","icon":"fas fa-cubes","image":{"name":"TO DO","img":"gradient.png"}},{"name":"Computer Graphics","description":"Recent interest","icon":"fas fa-lightbulb","image":{"name":"TO DO","img":"gradient.png"}},{"name":"Machine Learning","description":"NST is the life for me","icon":"fas fa-brain","image":{"name":"TO DO","img":"gradient.png"}}],"skillsets":[{"name":"What I Know","icon":"far fa-lightbulb","bulletPoints":[{"text":"Software development lifecycle","icon":"fas fa-arrow-alt-circle-right"},{"text":"Domain-driven design/modeling, UML","icon":"fas fa-arrow-alt-circle-right"},{"text":"UX lifecycle and related principles/tasks","icon":"fas fa-arrow-alt-circle-right"}]},{"name":"Have Experience With","icon":"fas fa-book","bulletPoints":[{"text":"Java, Git, JavaScript, HTML/CSS, Vue, Angular","icon":"fas fa-arrow-alt-circle-right"},{"text":"C++, C, C#, Python","icon":"fas fa-arrow-alt-circle-right"},{"text":"OpenGL, LaTeX, YAML, PHP","icon":"fas fa-arrow-alt-circle-right"},{"text":"Computer Graphics, Machine Learning","icon":"fas fa-arrow-alt-circle-right"},{"text":"Cool libs: SFML, LibGDX","icon":"fas fa-arrow-alt-circle-right"}]},{"name":"Want To Know","icon":"fas fa-exclamation","bulletPoints":[{"text":"Wider breadth of web dev skills","icon":"fas fa-arrow-alt-circle-right"},{"text":"More graphics APIs","icon":"fas fa-arrow-alt-circle-right"},{"text":"More operational work","icon":"fas fa-arrow-alt-circle-right"}]}],"contactInfo":{"emails":[{"address":"rmn6979@rit.edu","info":"School e-mail address"},{"address":"rmnill202mail@gmail.com","info":"Personal e-mail address"}],"socialMedia":[{"websiteName":"GitHub","link":"https://github.com/rmnill202/"},{"websiteName":"Twitter","link":"https://twitter.com/rmnill202"},{"websiteName":"LinkedIn","link":"https://www.linkedin.com/in/robert-nill-096b64112/"},{"websiteName":"Facebook","link":"https://www.facebook.com/robert.m.nill"}],"phone":"516-551-9679"},"headerLinks":{"left":[{"address":"https://www.linkedin.com/in/robert-nill-096b64112/","text":"LinkedIn","icon":{"name":"LinkedIn Icon","icon":"fab fa-linkedin"}},{"address":"https://github.com/rmnill202","text":"GitHub","icon":{"name":"GitHub Icon","icon":"fab fa-github-square"}}],"right":[{"address":"#projects","text":"Projects","icon":{"name":"","icon":""}},{"address":"#about","text":"About","icon":{"name":"","icon":""}},{"address":"#skillsets","text":"Skillsets","icon":{"name":"","icon":""}},{"address":"#contact","text":"Contact","icon":{"name":"","icon":""}},{"address":"","text":"Blog","icon":{"name":"","icon":""}}]}}

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_website_data_json__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_website_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_website_data_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_nav__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__welcome__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__projects__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__about__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__skillsets__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__contact__ = __webpack_require__(71);
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "main-page",
  data: function data() {
    return {
      websiteData: __WEBPACK_IMPORTED_MODULE_0__assets_website_data_json___default.a
    };
  },
  mounted: function mounted() {
    // console.log("Hello world!");
    // console.log(this.websiteData);
  },

  components: {
    HeaderNav: __WEBPACK_IMPORTED_MODULE_1__header_nav__["a" /* default */],
    Welcome: __WEBPACK_IMPORTED_MODULE_2__welcome__["a" /* default */],
    Projects: __WEBPACK_IMPORTED_MODULE_3__projects__["a" /* default */],
    About: __WEBPACK_IMPORTED_MODULE_4__about__["a" /* default */],
    Skillsets: __WEBPACK_IMPORTED_MODULE_5__skillsets__["a" /* default */],
    Contact: __WEBPACK_IMPORTED_MODULE_6__contact__["a" /* default */]
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_scrollto__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_scrollto__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header-nav',
  props: ['headerLinks'],
  directives: [__WEBPACK_IMPORTED_MODULE_0_vue_scrollto__["ScrollTo"]],
  data: function data() {
    return {
      leftLinks: this.headerLinks.left,
      rightLinks: this.headerLinks.right
    };
  }
});

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__welcome_gallery_vue__ = __webpack_require__(39);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'welcome',
  props: ['welcomePage'],
  components: { WelcomeGallery: __WEBPACK_IMPORTED_MODULE_0__welcome_gallery_vue__["a" /* default */] },
  data: function data() {
    return {
      title: this.welcomePage.websiteName,
      description: this.welcomePage.description,
      recentEvents: this.welcomePage.recentEvents,
      left: this.welcomePage.previewImages.left,
      right: this.welcomePage.previewImages.right,
      center: this.welcomePage.previewImages.center
    };
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_diamond_grid_vue__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'welcome-gallery',
  props: ['left', 'right', 'center'],
  components: { DiamondGrid: __WEBPACK_IMPORTED_MODULE_0__util_diamond_grid_vue__["a" /* default */] },
  data: function data() {
    return {
      pattern: [["i", "x"], 1, 2],
      altPattern: [["i", "x", "i"], 2],
      size: 120
    };
  },

  computed: {
    leftImages: function leftImages() {
      return this.imageArr(this.left);
    },
    rightImages: function rightImages() {
      return this.imageArr(this.right);
    },
    centerImage: function centerImage() {
      return __webpack_require__(1)("./" + this.center);
    },
    altImages: function altImages() {
      return this.imageArr(this.left);
    }
  },
  methods: {
    /** 
     * Construct an array of images. The require call is necessary to load the image.
     * @param source : The source array of images, which have not yet been required.
     * @return The array of image sources that can now be bound using v-bind!
     */
    imageArr: function imageArr(source) {
      var imgArr = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = source[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var img = _step.value;

          imgArr.push(__webpack_require__(1)("./" + img));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return imgArr;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_diamond_grid_vue__ = __webpack_require__(12);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54c50250_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_diamond_grid_vue__ = __webpack_require__(42);
function injectStyle (ssrContext) {
  __webpack_require__(41)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_diamond_grid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54c50250_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_diamond_grid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'diamond-grid',
  props: {
    /**
     * Defines the number of images/visual elements used for [n] rows, where [n] is the size of the array passed
     *   in as the pattern. The pattern will be repeated as many times as necessary for all images passed in to be
     *   displayed.
     *
     *  By default, patterns begin to fill the grid from the bottom left.
     *
     *  A pattern is contained within an object/array, and contains one of two types of pattern elements:
     *    1. Integers that define the number of images each row has.
     *    2. Arrays containing the characters 'i' or 'x', which represent 'image' and 'empty space' respectively.
     *
     *  An example containing both, and creates a grid of diamonds with an empty center.
     *  [ 1, 2, [i, x, i], 2, 1 ]
     */
    pattern: {
      type: Array,
      required: true
    },
    /** 
     * The index of the selected element, based on the array of elements passed into this component. If passed
     *   in, will be used to apply a "selected" styling to the element at the given index, and enables selection
     *   of elements. 
     */
    selection: {
      type: Number,
      required: false
    },
    /** 
     * An object that optionally defines styling to be applied to elements.
     */
    styling: {
      type: Object,
      required: false
    },
    /**
     * An array of visual elements to populate the grid with. Each element should be an object with a type
     *   parameter. Accepted types and formats are listed below:
     * Type: image
     *   src: Image URL
     *
     * Type: text
     *   text: The text that will be displayed.
     *   textStyle: The CSS styling that will be applied to the text.
     *   bgStyle: The CSS styling that will be applied to the background of the text.
     */
    elements: {
      type: Array,
      required: true
    },
    /** 
     * The width that will be applied to all visual elements, which must be consistent. If a width
     *   is not provided, then the width of the first image in the array of images will be used instead.
     */
    width: {
      type: Number,
      required: false,
      default: 200
    },
    /** 
     * The height that will be applied to all visual elements, which must be consistent. If a height
     *   is not provided, then the height of the first image in the array will be used instead.
     */
    height: {
      type: Number,
      required: false,
      default: 200
    },
    /**
     * The amount of spacing between rows of diamonds.
     */
    verticalSpacing: {
      type: Number,
      required: false,
      default: 5
    },
    /** 
     * The applied left and right margins for each image in the grid.
     */
    margins: {
      type: Number,
      required: false,
      default: 5
    },
    /**
     * If set to true, rows will be reversed when rendering.
     */
    flipVertical: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * If set to true, each row will be reversed.
     */
    flipHorizontal: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    /** 
     * @return True if there is no pattern array, or if the pattern object is empty.
     */
    noPattern: function noPattern() {
      return !this.pattern || this.pattern.length < 1;
    },

    /** 
     * @return True if there is no element array, or if the array is empty.
     */
    noElements: function noElements() {
      return !this.elements || this.elements.length < 1;
    },

    /** 
     * Based on the given list of elements and the pattern, construct an array of image rows,
     *  where the first row is what will be rendered at the top of the page. 
     */
    renderRows: function renderRows() {
      //Don't compute anything if we're missing the pattern or elements
      if (this.noPattern || this.noElements) return false;

      //Create an array of rows in order of the pattern. It'll be reversed later
      var rows = [];

      //Create rows until we run out of elements
      var elemIndex = 0,
          patternIndex = 0;

      while (elemIndex > -1) {
        var rowAndIndices = this.createRow(elemIndex, patternIndex);
        elemIndex = rowAndIndices.elemIndex;
        patternIndex = rowAndIndices.patternIndex;

        if (rowAndIndices.row) rows.push(this.flipHorizontal ? rowAndIndices.row.reverse() : rowAndIndices.row);
      }

      //Return there reversed order of elements by default, as we render top-down
      return rows.length > 0 ? this.flipVertical ? rows : rows.reverse() : undefined;
    },


    /** Row styling **/
    /****************/
    topRowStyle: function topRowStyle() {
      return { lineHeight: 0 };
    },
    rowStyle: function rowStyle() {
      return { marginTop: '-' + (this.height / 2 - this.verticalSpacing) + 'px', lineHeight: 0 };
    },


    /** Styling for elements & blank spaces **/
    /*****************************/
    allClass: function allClass() {
      return ['diamond'];
    },
    hoverableClass: function hoverableClass() {
      return ['hoverableDiamond'];
    },
    allStyle: function allStyle() {
      return { 'width': this.width + 'px', 'height': this.height + 'px',
        'marginLeft': this.margins + 'px', 'marginRight': this.margins + 'px',
        'minWidth': this.width + 'px' };
    },


    /** Styling for all elements **/
    /*****************************/
    elementClass: function elementClass() {
      return this.selection >= -1 ? this.hoverableClass : this.allClass;
    },
    elementStyle: function elementStyle() {
      return this.allStyle;
    },
    selectedStyle: function selectedStyle() {
      return Object.assign({}, this.elementStyle, { 'opacity': '0.5' });
    },


    /** Styling empty spaces **/
    /*****************************/
    emptyClass: function emptyClass() {
      return this.allClass;
    },
    emptyStyle: function emptyStyle() {
      return this.allStyle;
    }
  },
  methods: {
    /** 
     * Construct a row from the array of elements & pattern if possible.
     * @return An object containing the next element and pattern indices. If a row was created,
     *   then the row is also included in the object.
     */
    createRow: function createRow(elemIndex, patternIndex) {
      //Setup some short-hand temp variables
      var iElm = this.elements[elemIndex] ? elemIndex : -1;
      var iPat = this.pattern[patternIndex] ? patternIndex : 0;

      //Check if we have any remaining elements
      if (iElm == -1) {
        return { elemIndex: -1, patternIndex: -1 };
      }

      //Grab the next part of the pattern and initialize the new row
      var part = this.pattern[iPat];
      var row = [];

      //If the pattern part is an integer
      if (Number.isSafeInteger(part)) {

        //Grab the number of elements requested
        for (var toPush in this.elements.slice(iElm, iElm + part)) {
          row.push({ 'index': iElm, 'element': this.elements[iElm++] });
        }

        //Fill the rest of the row with empty stuff if necessary
        if (row.length < part) {
          for (var i = 0; i < part - row.length; i++) {
            row.push('');
          }
          iElm = -1;
        }
      }

      //If the pattern part is an array
      else if (Array.isArray(part)) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = part[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var el = _step.value;

              if (String(el).toLowerCase() === 'i') {
                //If element doesn't exist, set the element index to -1
                if (!this.elements[iElm]) {
                  iElm = -1;
                  row.push('');
                } else {
                  row.push({ 'index': iElm, 'element': this.elements[iElm++] });
                }
              } else if (String(el).toLowerCase() === 'x') {
                //Otherwise add some space to the row
                row.push('');
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }

      //Return the row and updated indices
      return { 'row': row.length > 0 ? row : undefined, 'elemIndex': iElm, 'patternIndex': iPat + 1 };
    },

    /** 
     * Inform the parent context that the selection has changed.
     * @param index : The index of the new selection, which matches an index located in the elements array.
     */
    selectElement: function selectElement(index) {
      this.$emit('selected', index);
    },

    /** 
     * @return True if the element's index indicates that it has been selected.
     */
    isSelected: function isSelected(index) {
      return index === this.selection;
    }
  }
});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/gradient.3d0f067.png";

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_project_preview_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_diamond_grid_vue__ = __webpack_require__(11);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'projects',
  props: ['projects'],
  components: { ProjectPreview: __WEBPACK_IMPORTED_MODULE_0__util_project_preview_vue__["a" /* default */], DiamondGrid: __WEBPACK_IMPORTED_MODULE_1__util_diamond_grid_vue__["a" /* default */] },
  data: function data() {
    return {
      selectedIndex: 6
    };
  },

  computed: {
    /** 
     * Images to be used for the grid of diamonds.
     */
    images: function images() {
      var projectData = [];

      //Loop through each project and gather the following data:
      for (var i = 0; i < this.projects.length; i++) {
        projectData.push(this.getImage(this.projects[i].preview.images));
      }

      return projectData;
    },

    /** 
     * Pull out any necessary project data into an array of objects.
     */
    projectData: function projectData() {
      var projectData = [];

      //Loop through each project and gather the following data:
      for (var i = 0; i < this.projects.length; i++) {
        var proj = this.projects[i];
        projectData.push({
          'name': proj.preview.name, //Name
          'description': proj.preview.description, //Description
          'image': this.getImage(proj.preview.images), //First image OR default image
          'startDate': proj.preview.startDate,
          'endDate': proj.preview.endDate,
          'links': proj.preview.links,
          'tags': proj.preview.tags,
          'key': i
        });
      }

      return projectData;
    },

    /** 
     * The currently selected object.
     */
    selected: function selected() {
      return this.projectData[this.selectedIndex];
    }
  },
  methods: {
    /** 
     * Update the currently selected project.
     */
    updateSelected: function updateSelected(newIndex) {
      this.selectedIndex = newIndex === this.selectedIndex ? -1 : newIndex;
    },

    /** 
     * Given an array of project images, load the first image, or a placeholder if the
     *   array is empty.
     */
    getImage: function getImage(images) {
      if (!images || !images.length) {
        return __webpack_require__(13);
      } else {
        return __webpack_require__(1)("./" + images[0].img);
      }
    },

    /** 
     * Meant for determining the number of grid-spaces to be taken up by a project in
     *   the smaller project view. Not used right now, but might be used again.
     */
    gridSize: function gridSize(index) {
      var length = this.projectData.length - 1;
      var full = index === 0 || index === length && length % 2;
      return _defineProperty({}, 'xs' + (full ? '12' : '6'), true);
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'project-preview',
  props: ['project', 'mediaHeight', 'width'],
  data: function data() {
    return {
      expanded: true,
      name: this.project.name,
      description: this.project.description,
      start: this.project.startDate,
      end: this.project.endDate,
      image: this.project.image,
      links: this.project.links,
      tags: this.project.tags
    };
  },

  computed: {
    /** 
     * Styling to be used for the preview image/text section.
     */
    mediaStyle: function mediaStyle() {
      return { 'height': this.mediaHeight || '' };
    },
    cardStyle: function cardStyle() {
      return { 'width': this.width || '' };
    }
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_list_card_vue__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'about',
  props: ['about'],
  components: { ListCard: __WEBPACK_IMPORTED_MODULE_0__util_list_card_vue__["a" /* default */] },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_card_vue__ = __webpack_require__(18);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8edf22c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_card_vue__ = __webpack_require__(66);
function injectStyle (ssrContext) {
  __webpack_require__(65)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8edf22c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'list-card',
  props: ['value', 'imgWidth', 'width', 'galleryWidth'],
  data: function data() {
    return {};
  },

  computed: {
    imgStyle: function imgStyle() {
      if (this.imgWidth) {
        return { 'width': this.imgWidth };
      }
    },
    cardStyle: function cardStyle() {
      if (this.width) {
        return { 'width': this.width };
      }
    },
    galleryStyle: function galleryStyle() {
      return this.galleryWidth ? { 'width': this.galleryWidth } : this.imgStyle;
    }
  },
  methods: {
    getSrc: function getSrc(item) {
      return __webpack_require__(1)("./" + item.img);
    }
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_list_card_vue__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'skillsets',
  props: ['skillsets'],
  components: { ListCard: __WEBPACK_IMPORTED_MODULE_0__util_list_card_vue__["a" /* default */] },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contact',
  props: ['contact'],
  data: function data() {
    return {};
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);


// Scroll to import
var VueScrollTo = __webpack_require__(8);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(VueScrollTo, {
  container: "body",
  duration: 600,
  easing: "ease-out",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]
  }
});

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(5);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb6e484e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(29);
function injectStyle (ssrContext) {
  __webpack_require__(27)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb6e484e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_vm._v(" "),_c('body',[_c('v-app',[_c('router-view')],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('head',[_c('link',{attrs:{"href":"https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Material+Icons","rel":"stylesheet"}}),_vm._v(" "),_c('link',{attrs:{"href":"https://use.fontawesome.com/releases/v5.9.0/css/all.css","rel":"stylesheet"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_main_page__ = __webpack_require__(32);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'main-page',
    component: __WEBPACK_IMPORTED_MODULE_2__components_main_page__["a" /* default */]
  }]
}));

/***/ }),
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_page_vue__ = __webpack_require__(6);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_655394bd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_page_vue__ = __webpack_require__(74);
function injectStyle (ssrContext) {
  __webpack_require__(33)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_page_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_655394bd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_page_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 33 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_nav_vue__ = __webpack_require__(7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32958462_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_nav_vue__ = __webpack_require__(36);
function injectStyle (ssrContext) {
  __webpack_require__(35)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_nav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32958462_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"flat":"","dense":""}},[_vm._l((_vm.leftLinks),function(link){return _c('v-btn',{key:link.id,staticClass:"hidden-xs-only",attrs:{"icon":"","href":link.address,"target":"_blank","rel":"noopener noreferrer"}},[_c('v-icon',[_vm._v(_vm._s(link.icon.icon))])],1)}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',{staticClass:"hidden-sm-and-down"},_vm._l((_vm.rightLinks),function(link){return _c('v-btn',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:(link.address),expression:"link.address"}],key:link.id,attrs:{"href":"#","flat":""}},[_vm._v(_vm._s(link.text))])})),_vm._v(" "),_c('v-menu',{staticClass:"hidden-md-and-up",attrs:{"transition":"slide-x-transition","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("menu")])],1),_vm._v(" "),_c('v-list',[_vm._l((_vm.rightLinks),function(link){return _c('v-list-tile',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:(link.address),expression:"link.address"}],key:link.id,attrs:{"href":"#"},on:{"click":function($event){}}},[_c('v-list-tile-title',[_vm._v(" "+_vm._s(link.text)+" ")])],1)}),_vm._v(" "),_c('v-divider',{staticClass:"hidden-sm-and-up"}),_vm._v(" "),_vm._l((_vm.leftLinks),function(link){return _c('v-list-tile',{key:link.id,staticClass:"hidden-sm-and-up",attrs:{"href":link.address,"target":"_blank"},on:{"click":function($event){}}},[_c('v-list-tile-title',[_vm._v(" "+_vm._s(link.text)+" ")])],1)})],2)],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_welcome_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0af268a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_welcome_vue__ = __webpack_require__(56);
function injectStyle (ssrContext) {
  __webpack_require__(38)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_welcome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0af268a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_welcome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 38 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_welcome_gallery_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_441a5e46_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_welcome_gallery_vue__ = __webpack_require__(55);
function injectStyle (ssrContext) {
  __webpack_require__(40)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_welcome_gallery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_441a5e46_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_welcome_gallery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.renderRows),function(row,index){return _c('div',{key:row.id,staticClass:"allRows",style:(index === 0 ? _vm.topRowStyle : _vm.rowStyle)},_vm._l((row),function(image){return (image)?_c('img',{class:_vm.elementClass,style:(_vm.isSelected(image.index) ? _vm.selectedStyle : _vm.elementStyle),attrs:{"src":image.element},on:{"click":function($event){_vm.selectElement(image.index)}}}):_c('div',{class:_vm.emptyClass,style:(_vm.emptyStyle)})}))}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/favicon.37395dd.png";

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/afrs_preview.1420c38.png";

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/capstone_preview_2.86e1696.png";

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/healthnet_preview.81e6736.png";

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/main_background_small.3c6ebdb.jpg";

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/pantreats_preview.7204feb.png";

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/raytrace.1644dbc.png";

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/thesis_placeholder.a61da6e.jpg";

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/vue-website-icon.8532cf1.png";

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/vue-website-icon2.ed84445.png";

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/website_preview_3.d36a0e9.png";

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/test.70d9076.png";

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('diamond-grid',{staticClass:"hidden-md-and-up altTop",attrs:{"elements":_vm.altImages,"pattern":_vm.altPattern,"width":_vm.size,"height":_vm.size}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('diamond-grid',{staticClass:"hidden-sm-and-down",attrs:{"elements":_vm.leftImages,"pattern":_vm.pattern,"width":_vm.size,"height":_vm.size,"flip-horizontal":"true"}}),_vm._v(" "),_c('img',{staticClass:"center",attrs:{"src":_vm.centerImage}}),_vm._v(" "),_c('diamond-grid',{staticClass:"hidden-sm-and-down",attrs:{"elements":_vm.rightImages,"pattern":_vm.pattern,"width":_vm.size,"height":_vm.size}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-divider'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('welcome-gallery',{staticStyle:{"filter":"drop-shadow(0px 3px 2px #000000)"},attrs:{"left":_vm.left,"right":_vm.right,"center":_vm.center}}),_vm._v(" "),_c('div',{staticClass:"description title"},[_vm._v(_vm._s(_vm.description))]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._l((_vm.recentEvents),function(event){return _c('div',{key:event.id,staticClass:"recentEvents"},[_c('div',{staticClass:"eventLeft"},[_vm._v(_vm._s(event.description))]),_vm._v(" "),_c('div',{staticClass:"eventRight"},[_vm._v(_vm._s(event.dateText))])])}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-divider')],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resume title"},[_c('a',{attrs:{"href":"https://people.rit.edu/rmn6979/2018_Robert_Nill_Software_Engineer_Resume.pdf"}},[_vm._v("Download my resume here - "),_c('i',{staticClass:"fas fa-file-alt"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_projects_vue__ = __webpack_require__(14);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c70fca4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_projects_vue__ = __webpack_require__(62);
function injectStyle (ssrContext) {
  __webpack_require__(58)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_projects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c70fca4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_projects_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 58 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_project_preview_vue__ = __webpack_require__(15);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26824dc8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_project_preview_vue__ = __webpack_require__(61);
function injectStyle (ssrContext) {
  __webpack_require__(60)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_project_preview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26824dc8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_project_preview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{style:(_vm.cardStyle)},[_c('v-card-media',{style:(_vm.mediaStyle),attrs:{"src":_vm.image}},[_c('v-card-text',[_c('span',{staticClass:"title imageText"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),(_vm.tags)?_c('div',{staticClass:"tagContainer"},[_vm._l((_vm.tags),function(tag){return [_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-icon',{staticStyle:{"padding-right":"10px"},attrs:{"slot":"activator","color":"white"},slot:"activator"},[_vm._v(_vm._s(tag.icon))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(tag.text))])],1)]})],2):_vm._e()])],1),_vm._v(" "),_c('v-card-actions',[_c('span',{},[_vm._v(_vm._s(_vm.description))])]),_vm._v(" "),_c('v-card-actions',[(_vm.start && _vm.end)?_c('span',{staticClass:"dateDisplay"},[_vm._v(_vm._s((_vm.start + " - " + _vm.end)))]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_vm._l((_vm.links),function(link){return _c('v-btn',{key:link.text,attrs:{"raised":"","color":"grey darken-1 white--text","small":"","target":"_blank","rel":"noopener noreferrer","href":link.url}},[_vm._v(_vm._s(link.text))])})],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_vm._v(" "),_c('h1',{attrs:{"id":"projects"}},[_vm._v("Projects")]),_vm._v(" "),_c('div',{staticClass:"hidden-sm-and-down larger"},[_c('div',{staticStyle:{"filter":"drop-shadow(0px 3px 2px #000000)"}},[_c('diamond-grid',{staticClass:"hidden-sm-and-down",attrs:{"elements":_vm.images,"pattern":[1,2],"selection":_vm.selectedIndex,"width":120,"height":120},on:{"selected":_vm.updateSelected}})],1),_vm._v(" "),_c('v-slide-x-reverse-transition',{attrs:{"mode":"out-in"}},[(_vm.selected)?_c('project-preview',{key:_vm.selected.key,attrs:{"project":_vm.selected,"mediaHeight":'450px',"width":'450px'}}):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"hidden-md-and-up smaller"},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.projectData),function(project,index){return _c('v-flex',{attrs:{"xs12":""}},[_c('project-preview',{attrs:{"project":_vm.projectData[_vm.projectData.length -1 -index],"mediaHeight":'120px'}})],1)}))],1)],1),_vm._v(" "),_c('br'),_c('v-divider')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__ = __webpack_require__(16);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b414198_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__ = __webpack_require__(67);
function injectStyle (ssrContext) {
  __webpack_require__(64)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b414198_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 64 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 65 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"cardStyle",style:(_vm.cardStyle)},[_c('v-card-title',{staticClass:"title"},[_c('div',{staticClass:"imgcontainer"},[(_vm.value.image)?_c('img',{staticClass:"optionalImage",style:(_vm.imgStyle),attrs:{"src":_vm.getSrc(_vm.value.image)}}):_vm._e(),_vm._v(" "),(_vm.value.icon && _vm.value.image)?_c('v-icon',{staticClass:"iconWithImage",staticStyle:{"font-size":"53px"}},[_vm._v(_vm._s(_vm.value.icon))]):(_vm.value.icon)?_c('v-icon',{staticClass:"optionalIcon",staticStyle:{"font-size":"53px"}},[_vm._v(_vm._s(_vm.value.icon))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.value.name)+" ")])]),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding-top":"0"}},[_c('span',[_vm._v(_vm._s(_vm.value.description))]),_vm._v(" "),(_vm.value.bulletPoints)?_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.value.bulletPoints),function(point){return _c('v-list-tile',[_c('v-list-tile-action',{staticStyle:{"min-width":"0","padding-right":"10px"}},[(point.icon)?_c('v-icon',[_vm._v(_vm._s(point.icon))]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-content',[_c('span',[_vm._v(_vm._s(point.text))])])],1)})):_vm._e(),_vm._v(" "),(_vm.value.gallery)?_c('v-container',{staticStyle:{"margin-top":"16px"},attrs:{"grid-list-xs":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.value.gallery),function(item){return _c('v-flex',{staticStyle:{"padding":"2px"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[(item.source)?_c('a',{attrs:{"slot":"activator","href":item.source},slot:"activator"},[_c('img',{staticClass:"galleryImage clickableImage",style:(_vm.galleryStyle),attrs:{"slot":"activator","src":_vm.getSrc(item)},slot:"activator"})]):_c('img',{staticClass:"galleryImage",style:(_vm.galleryStyle),attrs:{"slot":"activator","src":_vm.getSrc(item)},slot:"activator"}),_vm._v(" "),_c('span',[_vm._v("\n                "+_vm._s(item.text)+"\n                "),(item.source)?_c('div',{staticStyle:{"font-weight":"bold"}},[_vm._v("Click for source!")]):_vm._e()])])],1)],1)}))],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_vm._v(" "),_c('h1',{attrs:{"id":"about"}},[_vm._v("Interests")]),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.about),function(item){return _c('v-flex',[_c('list-card',{attrs:{"value":item,"img-width":'60px',"gallery-width":'100px',"width":'250px'}})],1)}))],1),_vm._v(" "),_c('br'),_c('v-divider')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_skillsets_vue__ = __webpack_require__(19);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4d2e382_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_skillsets_vue__ = __webpack_require__(70);
function injectStyle (ssrContext) {
  __webpack_require__(69)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_skillsets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4d2e382_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_skillsets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 69 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_vm._v(" "),_c('h1',{attrs:{"id":"skillsets"}},[_vm._v("Skillsets")]),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.skillsets),function(item){return _c('v-flex',[_c('list-card',{attrs:{"value":item,"img-width":'60px',"gallery-width":'70px',"width":'350px'}})],1)}))],1),_vm._v(" "),_c('br'),_c('v-divider')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contact_vue__ = __webpack_require__(20);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d443051_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_vue__ = __webpack_require__(73);
function injectStyle (ssrContext) {
  __webpack_require__(72)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d443051_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_vm._v(" "),_c('h1',{attrs:{"id":"contact"}},[_vm._v("Contact")]),_vm._v(" "),_c('div',{staticClass:"primaryContainer"},[_c('div',{staticClass:"email"},[_c('h2',[_vm._v("E-mail")]),_vm._v(" "),_vm._l((_vm.contact.emails),function(item){return _c('div',[_c('a',{attrs:{"href":("mailto:" + (item.address))}},[_vm._v(_vm._s(item.address))])])})],2),_vm._v(" "),_c('div',{staticClass:"phone"},[_c('h2',[_vm._v("Phone")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.contact.phone))])]),_vm._v(" "),_c('div',{staticClass:"links"},[_c('h2',[_vm._v("Links")]),_vm._v(" "),_vm._l((_vm.contact.socialMedia),function(item){return _c('div',[_c('a',{attrs:{"href":item.link}},[_vm._v(_vm._s(item.websiteName))])])})],2)]),_vm._v(" "),_c('br'),_c('v-divider')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-nav',{attrs:{"headerLinks":_vm.websiteData.headerLinks}}),_vm._v(" "),_c('welcome',{attrs:{"welcomePage":_vm.websiteData.welcomePage}}),_vm._v(" "),_c('projects',{attrs:{"projects":_vm.websiteData.projects}}),_vm._v(" "),_c('about',{attrs:{"about":_vm.websiteData.about}}),_vm._v(" "),_c('skillsets',{attrs:{"skillsets":_vm.websiteData.skillsets}}),_vm._v(" "),_c('contact',{attrs:{"contact":_vm.websiteData.contactInfo}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[21]);


// WEBPACK FOOTER //
// js/main.c2b06ddb2b245ecc3d05.js